import {Methods} from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeeDepartureApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'employee-departure'
  }

    public sendDepartMessage(formModel1: any) {
        return this.send(formModel1,"sendDepartMessage",Methods.GET)
    }
}